module.exports = __webpack_public_path__ + "assets/img/kv-4fdc036f.jpg";